import { createSlice } from '@reduxjs/toolkit';

export const attendanceAuditReportIdSlice = createSlice({
  name: 'delta/attendanceAuditReportId',
  initialState: null,
  reducers: {
    getAttendanceAuditReportId: (state, action) => action.payload,
    resetAttendanceAuditReportId: () => null,
  },
});

export const { getAttendanceAuditReportId, resetAttendanceAuditReportId } =
  attendanceAuditReportIdSlice.actions;

export default attendanceAuditReportIdSlice.reducer;
